<template>
  <div id="container">
    <div class="product-status">
      <div class="bold"></div>
      <el-tabs v-model="activeName" @tab-click="onReset">
        <el-tab-pane
          v-for="(item, index) in sellRecordcountTabs"
          :label="item.title"
          :name="item.name"
          class="tab-text"
          :key="index"
        ></el-tab-pane>
      </el-tabs>
      <div class="item-box-content" style="padding-bottom:0">
        <el-form label-width="70px" label-position="right">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="备货编号：" v-show="activeName==='1'">
                <el-input v-model="valList[0].value"></el-input>
              </el-form-item>
              <el-form-item label="发货编号：" v-show="activeName==='2'">
                <el-input v-model="valList[1].value"></el-input>
              </el-form-item>
              <el-form-item label="开票编号：" v-show="activeName==='3'">
                <el-input v-model="valList[2].value"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6" v-show="activeName==='2'">
              <el-form-item label="出库单编号：" label-width="84px">
                <el-input v-model="valList[3].value" :disabled="false"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="合同编号：">
                <el-input v-model="valList[4].value"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="客户合同编号：" label-width="98px">
                <el-input v-model="valList[5].value"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="公司名称：">
                <el-input v-model="valList[6].value"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="备货方式：" v-show="activeName==='1'">
                <el-select v-model="valList[7].value">
                  <el-option value="直发备货"></el-option>
                  <el-option value="入库备货"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="发货方式：" v-show="activeName==='2'">
                <el-select v-model="valList[8].value">
                  <el-option value="快递配送"></el-option>
                  <el-option value="物流配送"></el-option>
                  <el-option value="客户自提"></el-option>
                  <el-option value="仓库配送"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="发票类型：" v-show="activeName==='3'">
                <el-select v-model="valList[9].value">
                  <el-option value="普通发票"></el-option>
                  <el-option value="专用发票"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6" v-show="activeName!=='3'">
              <el-form-item :label="activeName==='1'?'请求备货时间：':'请求发货时间：'" label-width="98px">
                <el-date-picker
                  v-model="valList[10].value"
                  type="date"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                  style="width:100%"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="备货状态：" v-show="activeName==='1'">
                <el-select v-model="valList[11].value">
                  <el-option value="1" label="备货审核"></el-option>
                  <el-option value="6" label="审核不通过"></el-option>
                  <el-option value="2" label="待配货"></el-option>
                  <el-option value="3" label="配货中" v-if="valList[7].value!=='入库备货'"></el-option>
                  <el-option value="4" label="备货中"></el-option>
                  <el-option value="5" label="已备货"></el-option>
                  <el-option value="7" label="释放库存审核中"></el-option>
                  <el-option value="8" label="释放库存审核通过"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="开票状态：" v-show="activeName==='3'">
                <el-select v-model="valList[12].value">
                  <el-option value="1" label="开票审核"></el-option>
                  <el-option value="3" label="审核不通过"></el-option>
                  <el-option value="2" label="已开票"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="发货状态：" v-show="activeName==='2'&&showAll">
                <el-select v-model="valList[13].value">
                  <el-option value="1" label="发货审核"></el-option>
                  <el-option value="4" label="审核不通过"></el-option>
                  <el-option value="2" label="发货中"></el-option>
                  <el-option value="3" label="已发货"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6" v-show="activeName==='3'">
              <el-form-item label="开票时间：">
                <el-date-picker
                  v-model="valList[14].value"
                  type="date"
                  style="width:100%"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="activeName==='2'&&showAll?24:6" style="text-align: right">
              <el-button type="primary" @click="onSearch">搜索</el-button>
              <el-button @click="onReset" style="margin-bottom:20px">重置</el-button>
              <el-button :loading="exportLoading" @click="handleExport" style="margin-bottom:20px">导出</el-button>
              <el-button type="text" @click="showAll = !showAll" v-show="activeName==='2'">
                {{showAll?'收起':'展开'}}
                <i
                  :class="showAll ? 'el-icon-arrow-up ': 'el-icon-arrow-down'"
                ></i>
              </el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div
        class="box-table"
        :style="{height:showAll?$store.state.Sell.height-97+'px': $store.state.Sell.height-48+'px'}"
      >
        <!------------------------------------ 备货列表 ------------------------------------>
        <el-table
          v-show="activeName==='1'"
          border
          :data="list1"
          :header-cell-style="tableHeader"
          v-loading="loadingTable"
          element-loading-text="拼命加载中请稍后..."
          :max-height="$store.state.Sell.height-48"
          element-loading-spinner="el-icon-loading"
        >
          <el-table-column label="备货编号" width="150" show-overflow-tooltip fixed>
            <template slot-scope="scope">
              <span class="approval" @click="toDetail(scope.row)">{{scope.row.stockupCode}}</span>
            </template>
          </el-table-column>
          <el-table-column label="合同编号" width="150" show-overflow-tooltip fixed>
            <template slot-scope="scope">
              <span class="approval" @click="onContractCode(scope.row)">{{scope.row.contractCode}}</span>
            </template>
          </el-table-column>
          <el-table-column label="客户合同编号" width="125" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="line-limit-length">{{scope.row.customerContractCode||'--'}}</div>
            </template>
          </el-table-column>
          <el-table-column label="公司名称" prop="cusName" width="180" show-overflow-tooltip>
            <template slot-scope="scope">
              <div
                class="approval line-limit-length"
                @click="toKeHu(scope.row)"
              >{{scope.row.cusName}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="stockupType" label="备货方式"></el-table-column>
          <el-table-column label="备货信息" prop="mark" width="210"></el-table-column>
          <el-table-column label="请求备货时间" width="125">
            <template slot-scope="scope">{{scope.row.createDate|dateFilter}}</template>
          </el-table-column>
          <el-table-column label="预计发货时间" width="110">
            <template slot-scope="scope">{{scope.row.deliveryTime|dateFilterD}}</template>
          </el-table-column>
          <el-table-column label="备货状态" width="120">
            <template slot-scope="scope">{{scope.row.stockupState|stockupStateFilter}}</template>
          </el-table-column>
          <el-table-column label="备货时间" width="125">
            <template
              slot-scope="scope"
            >{{(scope.row.stockupState===5? scope.row.processDate:null)|dateFilterL}}</template>
          </el-table-column>
          <el-table-column label="备货进度" width="150">
            <template slot-scope="scope">
              <el-progress
                :percentage="parseInt((scope.row.stockup>1?1:scope.row.stockup)*100)"
                color="#276cff"
              ></el-progress>
            </template>
          </el-table-column>
        </el-table>

        <!------------------------------------ 发货列表 ------------------------------------>
        <el-table
          v-show="activeName==='2'"
          border
          :data="list2"
          :header-cell-style="tableHeader"
          v-loading="loadingTable"
          element-loading-text="拼命加载中请稍后..."
          :max-height="showAll?$store.state.Sell.height-97: $store.state.Sell.height-48"
          element-loading-spinner="el-icon-loading"
        >
          <el-table-column label="发货编号" fixed width="150">
            <template slot-scope="scope">
              <span class="approval" @click="toFaHuo(scope.row)">{{scope.row.deliverNumber}}</span>
            </template>
          </el-table-column>
          <el-table-column label="出库单编号" width="130" show-overflow-tooltip>
            <template slot-scope="scope">{{scope.row.outstockNumber||'--'}}</template>
          </el-table-column>
          <el-table-column label="合同编号" width="150">
            <template slot-scope="scope">
              <span class="approval" @click="onContractCode(scope.row)">{{scope.row.contractCode}}</span>
            </template>
          </el-table-column>
          <el-table-column label="客户合同编号" width="125" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="line-limit-length">{{scope.row.customerContractCode||'--'}}</div>
            </template>
          </el-table-column>
          <el-table-column label="公司名称" width="180" show-overflow-tooltip>
            <template slot-scope="scope">
              <div
                class="approval line-limit-length"
                @click="toKeHu(scope.row)"
              >{{scope.row.cusName}}</div>
            </template>
          </el-table-column>
          <el-table-column label="发货方式" prop="deliverMode"></el-table-column>
          <el-table-column label="发货信息" prop="mark" width="210"></el-table-column>
          <el-table-column label="请求发货时间" width="125">
            <template slot-scope="scope">{{scope.row.createDate|dateFilter}}</template>
          </el-table-column>
          <el-table-column label="实际发货时间" width="125">
            <template slot-scope="scope">{{scope.row.outDate|dateFilterL}}</template>
          </el-table-column>
          <el-table-column label="发货状态" width="120">
            <template slot-scope="scope">{{scope.row.deliverState|deliverStateFilter}}</template>
          </el-table-column>
        </el-table>

        <!------------------------------------ 开票列表 ------------------------------------>
        <el-table
          v-show="activeName==='3'"
          border
          :data="list3"
          :header-cell-style="tableHeader"
          v-loading="loadingTable"
          element-loading-text="拼命加载中请稍后..."
          :max-height="$store.state.Sell.height-48"
          element-loading-spinner="el-icon-loading"
        >
          <el-table-column label="开票编号" width="150" show-overflow-tooltip>
            <template slot-scope="scope">
              <span
                class="approval"
                @click="onInvoiceNumber(scope.row)"
              >{{ scope.row.invoiceNumber }}</span>
            </template>
          </el-table-column>
          <el-table-column label="合同编号" width="150" show-overflow-tooltip>
            <template slot-scope="scope">
              <span class="approval" @click="onContractCode(scope.row)">{{ scope.row.contractCode }}</span>
            </template>
          </el-table-column>
          <el-table-column label="客户合同编号" width="125" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="line-limit-length">{{scope.row.customerContractCode||'--'}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="cusName" label="公司名称" min-width="150" show-overflow-tooltip>
            <template slot-scope="scope">
              <div
                class="approval line-limit-length"
                @click="toKeHu(scope.row)"
              >{{scope.row.cusName}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="amount" label="发票金额" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.amount | priceFilter }}</template>
          </el-table-column>
          <el-table-column prop="createUser" label="申请人"></el-table-column>
          <el-table-column label="申请时间" width="125">
            <template slot-scope="scope">{{ scope.row.createDate | dateFilterL }}</template>
          </el-table-column>
          <el-table-column prop="invoiceType" label="发票类型" width="80">
            <template slot-scope="scope">
              <span
                v-if="scope.row.invoiceType==='红字发票'"
                style="color:#D35E5E"
              >{{scope.row.invoiceType}}</span>
              <span v-else>{{scope.row.invoiceType}}</span>
            </template>
          </el-table-column>
          <el-table-column label="开票状态" width="100">
            <template slot-scope="scope">{{ scope.row.state|invoiceStateFilter}}</template>
          </el-table-column>
          <el-table-column label="是否合并开票" width="110">
            <template slot-scope="scope">{{ scope.row.isMeger === 1 ? "是" : "否" }}</template>
          </el-table-column>
          <el-table-column prop="invoiceCode" label="发票编号" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.invoiceCode||'--' }}</template>
          </el-table-column>
          <el-table-column label="开票时间" width="125">
            <template slot-scope="scope">{{ scope.row.invoiceDate | dateFilterL }}</template>
          </el-table-column>
          <el-table-column prop="receivePeople" label="处理人" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.receivePeople||'--' }}</template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <pagination
          :total="total"
          :currentPage="currentPage"
          :pageSize="pageSize"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
        ></pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { downLoadFileBlob } from '@/util/tool'
import { sellRecordcountTabs } from './util/data'
import {
  queryStockupByOwnId,
  billingRecordExport,
  stockingRecordExport,
  deliveryRecordExport
  // queryDeliverByOwnId,
  // queryStateByListVoice
} from '@/api/sell/sellManage'
import pagination from '@/components/pagination'
export default {
  components: { pagination },
  data() {
    return {
      valList: [
        { value: '', column: 'stockupCode' },
        { value: '', column: 'deliverNumber' },
        { value: '', column: 'invoiceNumber' },
        { value: '', column: 'outstockNumber' },
        { value: '', column: 'contractCode' },
        { value: '', column: 'customerContractCode' },
        { value: '', column: 'cusName' },
        { value: '', column: 'stockupType' },
        { value: '', column: 'deliverMode' },
        { value: '', column: 'invoiceType' },
        { value: '', column: 'createDate' },
        { value: '', column: 'stockupState' },
        { value: '', column: 'state' },
        { value: '', column: 'deliverState' },
        { value: '', column: 'invoiceDate' }
      ],
      showAll: false, // 是否展开全部 !展开
      searchList: [],
      activeName: '1',
      sellRecordcountTabs, // tab
      list1: [], // 备货 列表数据
      list2: [], // 发货 列表数据
      list3: [], // 开票 列表数据
      loadingTable: false, // 列表loading
      pageSize: 30, // 页数
      currentPage: 1, // 页码
      total: 0, // 列表总数
      exportLoading: false
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    toDetail(row) {
      // 备货详情
      this.$router.push({ name: 'stockUpEdit', query: { id: row.ocsId } })
    },
    toFaHuo(row) {
      // 发货详情
      this.$router.push({ name: 'shipmentsEdit', query: { ocdId: row.odgId } })
    },
    onInvoiceNumber(row) {
      // 开票详情
      if (row.invoiceType === '红字发票') {
        this.$router.push({
          name: 'returnTicketEdit',
          query: { oisId: row.ociId }
        })
      } else {
        this.$router.push({
          name: 'makeOutAnInvoiceEdit',
          query: { ociId: row.ociId }
        })
      }
    },
    // 合同详情
    onContractCode(row) {
      this.$router.push({
        name: 'contractEdit',
        query: { id: row.ocbId, cusId: row.cusId }
      })
    },
    // 客户详情
    toKeHu(row) {
      this.$router.push({
        path: '/crm/customer/details',
        query: { id: row.cusId }
      })
    },
    onReset() {
      this.showAll = false
      this.valList.forEach((ele) => {
        delete ele.value
      })
      this.searchList = []
      this.pageSize = 30
      this.currentPage = 1
      this.getList()
    },
    onSearch() {
      // 搜索
      this.searchList = []
      if (this.valList.some((ele) => ele.value)) {
        this.pageSize = 30
        this.currentPage = 1
        this.valList.forEach((ele) => {
          if (ele.value) {
            ele.collection = true
            this.searchList.push(ele)
          }
        })
        this.getList()
      } else {
        this.$message.error('搜索条件不能为空')
      }
    },
    getList() {
      this.loadingTable = true
      const params = {
        criteriaVoList: this.searchList,
        queryPageName: ''
      }
      const str =
        this.activeName === '1'
          ? 'orderContractStockup/queryStockupByOwnId'
          : this.activeName === '2'
            ? 'orderContractDeliverGoods/queryDeliverByOwnId'
            : 'orderContractInvoice/queryStateByList'
      const arr = [str, 0, this.currentPage, this.pageSize, params]
      queryStockupByOwnId(...arr).then((res) => {
        if (res.data.code === 200) {
          this.loadingTable = false
          if (this.activeName === '1') {
            this.list1 = res.data.obj.records
          } else if (this.activeName === '2') {
            this.list2 = res.data.obj.records
          } else {
            this.list3 = res.data.obj.records
          }
          this.total = res.data.obj.total
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 设置头部背景色
    tableHeader({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 页数
    handleSizeChange(val) {
      this.currentPage = 1
      this.pageSize = val
      this.getList()
    },
    // 页码
    handleCurrentChange(val) {
      this.currentPage = val
      this.getList()
    },
    handleExport() {
      const queryCriteriaVo = { criteriaVoList: [] }
      this.exportLoading = true
      if (this.valList.some((ele) => ele.value)) {
        this.pageSize = 30
        this.currentPage = 1
        this.valList.forEach((ele) => {
          if (ele.value) {
            ele.collection = true
            queryCriteriaVo.criteriaVoList.push(ele)
          }
        })
      }
      const params = {
        invoicePayUrl: '',
        orderContractInvoiceListVos: [],
        queryCriteriaVo
      }
      switch (this.activeName) {
        case '1':
          params.invoicePayUrl = '60b5c86a67e47711c4c23256'
          this.stockingRecordExport(params)
          break
        case '2':
          params.invoicePayUrl = '60b5cf8767e47711c4c23260'
          this.deliveryRecordExport(params)
          break
        case '3':
          params.invoicePayUrl = '60b44bac67e41b98c1e03bc1'
          this.billingRecordExport(params)
          break
      }
    },
    // 开票记录
    billingRecordExport(params) {
      billingRecordExport(params)
        .then(res => {
          if (res.status === 200) downLoadFileBlob(this, res)
        })
        .catch(err => {
          this.$message.error(err)
        })
        .finally(() => {
          this.exportLoading = false
        })
    },
    // 备货记录
    stockingRecordExport(params) {
      stockingRecordExport(params)
        .then(res => {
          if (res.status === 200) downLoadFileBlob(this, res)
        })
        .catch(err => {
          this.$message.error(err)
        })
        .finally(() => {
          this.exportLoading = false
        })
    },
    // 发货记录
    deliveryRecordExport(params) {
      deliveryRecordExport(params)
        .then(res => {
          if (res.status === 200) downLoadFileBlob(this, res)
        })
        .catch(err => {
          this.$message.error(err)
        })
        .finally(() => {
          this.exportLoading = false
        })
    }
  }
}
</script>
